var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeCompanyDirectionSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5351562,11.1210938L18.4140625,1C17.125-0.2890625,14.875-0.2890625,13.5859375,1L3.4648438,11.1210938 C2.5205078,12.0654297,2,13.3212891,2,14.6572266V30c0,1.1025391,0.8974609,2,2,2h7c1.1025391,0,2-0.8974609,2-2v-9h6v9 c0,1.1025391,0.8974609,2,2,2h7c1.1025391,0,2-0.8974609,2-2V14.6572266C30,13.3212891,29.4794922,12.0654297,28.5351562,11.1210938 z M28,30h-7v-9c0-1.1025391-0.8974609-2-2-2h-6c-1.1025391,0-2,0.8974609-2,2v9H4V14.6572266 c0-0.8017578,0.312479-1.5556641,0.8789062-2.1220703L15,2.4140625c0.5351562-0.5332031,1.4648438-0.5332031,2,0 l10.1210938,10.1210938C27.687479,13.1015625,28,13.8554688,28,14.6572266V30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCompanyDirectionSmall);
export default __webpack_public_path__ + "static/media/home-company-direction--small.74ff138a06dcc9ea952d3d18eff7784d.svg";
export { ForwardRef as ReactComponent };